module.exports = __webpack_public_path__ + "static/media/IMG-20220519-WA0016.39e0c0f4.jpg";